import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ganadorso2',
  templateUrl: './ganadorso2.component.html',
  styleUrls: ['./ganadorso2.component.scss']
})
export class Ganadorso2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
